import React, { useContext, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { AccessLevel, LawPortalFeature, Module, OrganizationFeature, UserContext } from '../../../../../Context/UserContext/UserContext';
import { Button, Grid, makeStyles } from '@material-ui/core';
import { CompanyUnitSelectDialog } from './../../../../../Components';
import { OtherRequirementWizard } from '../OtherRequirementWizard';
import { UpdateConnectionWizardDialog } from '../UpdateConnectionWizard';

const useStyles = makeStyles(() => ({
  topActionContainer: {
    marginBottom: '1rem',
    display: 'flex',
  },
}));

interface ICustomerLawListActionsProps {
  onDeleteComplete?: () => void;
}

export const CustomerOtherRequirementActions = ({ onDeleteComplete }: ICustomerLawListActionsProps) => {
  const { hasAccessToFeature,hasAccessToModule, getCompanyUnitName } = useContext(UserContext);
  const canManage = hasAccessToModule(Module.Organization) && hasAccessToFeature(OrganizationFeature.Manage, AccessLevel.Administer)
 const accessToOtherRequirements = hasAccessToFeature(LawPortalFeature.Manage, AccessLevel.Manage);
  const [editLegalListDialogOpen, setEditLegalListDialogOpen] = useState<boolean>(false);
  const [connectionWizardOpen, setConnectionWizardOpen] = useState<boolean>(false);
  const { formatMessage } = useIntl();
  const classes = useStyles();


  const openEditOtherRequirement = () => {
    setEditLegalListDialogOpen(true);
  };

  const openConnectionWizard = () => {
    setConnectionWizardOpen(true);
  };




  if (!accessToOtherRequirements) {
    return null;
  }

  const handleWizardComplete = () => {
    setEditLegalListDialogOpen(false);
    onDeleteComplete?.();
  };

  const handleConnectionWizardComplete = () => {
    if (onDeleteComplete) {
      onDeleteComplete();
    }
  };

  return (
    <>
      <Grid container justify="flex-end" className={classes.topActionContainer} spacing={1} direction="row">
        <Grid item>
          <Button onClick={openConnectionWizard} variant="outlined">
            <FormattedMessage id="law-portal.manage.law-list.update-laws" />
          </Button>
        </Grid>
        <Grid item>
          <Button onClick={openEditOtherRequirement} variant="outlined">
            <FormattedMessage id="law-portal.manage.other-requiremnt.editOtherRequirement" />
          </Button>
        </Grid>
      </Grid>

      <OtherRequirementWizard
        open={editLegalListDialogOpen}
        onClose={() => setEditLegalListDialogOpen(false)}
        onComplete={handleWizardComplete}
      />
      <UpdateConnectionWizardDialog
        open={connectionWizardOpen}
        onClose={() => setConnectionWizardOpen(false)}
        onComplete={handleConnectionWizardComplete}
      />
    </>
  );
};
